export const menuActions_setCompanyMenu = (companyMenu) => { return { type: 'SETCOMPANYMENU', payload: companyMenu } };
export const menuActions_setCompanyTopMenu = (companyMenu) => { return { type: 'SETCOMPANYTOPMENU', payload: companyMenu } };
export const menuActions_setCompanySubMenu = (companyMenu) => { return { type: 'SETCOMPANYSUBMENU', payload: companyMenu } };

export const menuReducer_setTotalMenuLinks = (thisLinks) => { return { type: 'SETTOTALMENULINKS', payload: thisLinks } };
export const menuReducer_setTotalMenu = (thisMenus) => { return { type: 'SETTOTALMENUL', payload: thisMenus } };

export const menuActions_setMenuReset = () => { return { type: 'SETMENURESET' } };